import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { environment } from '../../environments/environment';
import {
  FileMovementLog,
  FileMovementLogApiResponse,
  FileMovementLogResult,
} from '../models/file-movement-log.model';

interface FileMovementLogsApiEnvelope {
  logs?: FileMovementLogApiResponse[];
  fileMovementLogs?: FileMovementLogApiResponse[];
  items?: FileMovementLogApiResponse[];
  totalCount?: number;
  TotalCount?: number;
}

@Injectable({
  providedIn: 'root',
})
export class FileMovementLogsService {
  private readonly baseUrl = environment.apiUrl + 'SFTPMigration';
  private readonly endpoint = 'FileMovementLogs';

  constructor(private http: HttpClient) {}

  getLogs(
    skip = 0,
    count = 10,
    sortBy = 'date',
    sortDir: 'asc' | 'desc' = 'desc',
    filters?: {
      client?: string;
      status?: string;
      fromDate?: string;
      toDate?: string;
    },
  ): Observable<FileMovementLogResult> {
    let params = new HttpParams()
      .set('skip', skip.toString())
      .set('count', count.toString())
      .set('sortBy', sortBy)
      .set('sortDir', sortDir);

    if (filters?.client?.trim()) {
      params = params.set('client', filters.client.trim());
    }
    if (filters?.status?.trim()) {
      params = params.set('status', filters.status.trim());
    }
    if (filters?.fromDate) {
      params = params.set('fromDate', filters.fromDate);
    }
    if (filters?.toDate) {
      params = params.set('toDate', filters.toDate);
    }

    return this.http
      .get<FileMovementLogApiResponse[] | FileMovementLogsApiEnvelope>(
        `${this.baseUrl}/${this.endpoint}`,
        {
          headers: this.getHeaders(),
          params,
        },
      )
      .pipe(
        map((response) => {
          const records = Array.isArray(response)
            ? response
            : (response.logs ??
              response.fileMovementLogs ??
              response.items ??
              []);
          const totalCount = Array.isArray(response)
            ? records.length
            : (response.totalCount ?? response.TotalCount ?? records.length);

          return {
            logs: records.map((record) => this.mapRecord(record)),
            totalCount,
          };
        }),
      );
  }

  private getHeaders(): HttpHeaders {
    return new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8',
    });
  }

  private mapRecord(record: FileMovementLogApiResponse): FileMovementLog {
    return {
      s3Bucket: record.S3Bucket ?? '',
      inputFilePath: record.InputFilePath ?? '',
      configId: record.ConfigId?.toString() ?? '',
      client: record.Client ?? '',
      sourcePath: record.SourcePath ?? '',
      destinationPath: record.DestinationPath ?? '',
      fileName: record.FileName ?? '',
      status: record.Status ?? '',
      statusDesc: record.StatusDesc ?? '',
      date: record.Date ?? '',
    };
  }
}
